module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="b-ticket-popup-offers">' +
((__t = ( L10N.get('b2b.pages.booking.ticket.toCoordination') )) == null ? '' : __t) +
': ' +
((__t = ( data.length )) == null ? '' : __t) +
'</div>\n';

}
return __p
}